import { createSlice } from '@reduxjs/toolkit';
import { TeamGroup } from 'modules/championship/domain/interfaces/team-group';
import groupsAdapter from './groups.adapter';
import { deleteStageTeamGroup, fetchStages, updateStageGroups, upsertStageTeamGroup } from './stages.actions';

const groupsSlice = createSlice({
  name: 'groups',
  initialState: groupsAdapter.getInitialState({
    entities: {},
  }),
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchStages.fulfilled, (state, action) => {
      const groups = action.payload.reduce<TeamGroup[]>((acc, stage) => [...acc, ...stage.teamGroups], []);

      groupsAdapter.setAll(state, groups);
    });

    builder.addCase(deleteStageTeamGroup.fulfilled, (state, action) => {
      const teamGroupId = action.meta.arg;
      groupsAdapter.removeOne(state, teamGroupId);
    });

    builder.addCase(upsertStageTeamGroup.fulfilled, (state, action) => {
      groupsAdapter.upsertOne(state, action.payload);
    });

    builder.addCase(updateStageGroups, (state, action) => {
      const { stageId, groups } = action.payload;
      const existingIds = groupsAdapter
        .getSelectors()
        .selectAll(state)
        .filter((g) => g.stageId === stageId)
        .map((g) => g.id);
      groupsAdapter.removeMany(state, existingIds);
      groupsAdapter.upsertMany(state, groups);
    });
  },
});

export default groupsSlice;
